import compose from 'lodash/flowRight';
import React from 'react';
import {graphql} from '@apollo/client/react/hoc';
import {gql} from '@apollo/client';
import {Chip, createStyles, Grid, makeStyles, withStyles} from '@material-ui/core';

import {MaterialDesignIcon} from 'components/Icons';

import {interestsItems} from '../../../../consts/targetingValues';
import {NameValueMetaObj} from '../../../../consts/utilities';
import {black, purple, white} from 'consts/brand.integration';

interface Props {
  influencer: Influencer;
  updateInfluencer: (id: string, nextInterests: string[]) => void;
}

const InfluencerInterests: React.FC<Props> = ({influencer, updateInfluencer}) => {
  const classes = useStyles();

  const handleToggleInterest = (selectedIds: string[], toggledId: string) => {
    const hasInterest = selectedIds.some((id: string) => id === toggledId);
    const nextInterests = hasInterest
      ? selectedIds.filter((value: string) => value !== toggledId)
      : [...selectedIds, toggledId];

    updateInfluencer(influencer.id, nextInterests);
  };

  const isSelected = (currentInterest: NameValueMetaObj) => {
    return influencer.interests?.some(interest => interest?.id === currentInterest.value);
  };

  return (
    <Grid
      container
      className={classes.root}
      justifyContent="space-between"
      direction="row"
      spacing={1}
    >
      {interestsItems.map((item, index) => (
        <Grid key={index} item>
          <CustomChip
            label={item.name}
            icon={<MaterialDesignIcon icon={item.meta ?? ''} />}
            color={isSelected(item) ? 'primary' : 'secondary'}
            onClick={() =>
              handleToggleInterest(
                influencer.interests?.map(interest => interest?.id),
                item.value
              )
            }
          />
        </Grid>
      ))}
    </Grid>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      position: 'relative',
      flexWrap: 'wrap',
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
  })
);

const CustomChip = withStyles(theme => ({
  colorPrimary: {
    color: `${white}`,
    borderColor: `${purple}`,
    backgroundColor: `${purple}`,
  },
  colorSecondary: {
    color: `${black}70`,
    borderColor: `${black}10`,
    backgroundColor: `${black}10`,
  },
  root: {
    '&:hover': {
      color: `${white}`,
      borderColor: `${purple}70`,
      backgroundColor: `${purple}70`,
    },
    '&:focus': {
      color: `${white}`,
      borderColor: `${purple}`,
      backgroundColor: `${purple}`,
    },
  },
}))(Chip);

export default compose(
  graphql(
    gql`
      mutation updateInfluencer($id: UUIDString!, $interestIds: [UUIDString]) {
        updateInfluencer(id: $id, interestIds: $interestIds) {
          ok
          influencer {
            id
            interests {
              id
            }
          }
        }
      }
    `,
    {
      props: ({mutate}) => ({
        updateInfluencer: (id, interests) =>
          mutate({
            variables: {
              id,
              interestIds: interests,
            },
          }),
      }),
    }
  )
)(InfluencerInterests);
